import { HowdenApiEnviroment, IHowdenApiInfo } from '@howdeniberia/core-front';
import { APP_CONSTANTS } from './../app/core/constants/general-constants';

export const ApiConfigurations: IHowdenApiInfo[] = [
  {
    name: APP_CONSTANTS.API_TELADOC_NAME,
    paths: {
      local: 'https://localhost:7249',
      development: 'https://how-apitelesuscripcion.app-dev.howdeniberia.com',
      staging: 'https://how-apitelesuscripcion.app-staging.howdeniberia.com',
      production: 'https://how-apitelesuscripcion.app.howdeniberia.com'
    },
    useEnviroment: HowdenApiEnviroment.ENVIROMENT_CHOOSE,
    needsToken: true
  }
] as IHowdenApiInfo[];
